<template>
  <v-container class="ma-0 pa-0 pb-8">
    <v-row class="pt-10 px-8 pb-12">
      <strong>Filtros</strong>
      <v-spacer></v-spacer>
      <v-btn small class="elevation-0" style="border:1px solid #dddddd;" @click="removeFilter">
        <v-icon small class="mr-1">mdi-filter-off</v-icon>Limpiar
      </v-btn>

      <v-text-field label="Nombre" v-model="model.name" />
      <v-text-field label="Apellido" v-model="model.last" />

      <v-text-field label="Email" v-model="model.email" />
      <v-text-field label="Teléfono" v-model="model.phone" />
      <v-text-field label="Puesto" v-model="model.job_position" />

      <v-select
        label="Acceso al portal"
        v-model="model.has_portal_access"
        :items="siyno"
        item-text="text"
        item-value="value"
      />
    </v-row>

    <v-card style="position:absolute; bottom:0; width:100%;" tile color="primary">
      <v-list-item link dark @click="apply">
        <v-list-item-content>
          <strong>Filtrar ({{ counter }})</strong>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ContactsFilter',
  data: () => ({
    siyno: [
      { text: '(Todos)', value: '' },
      { text: 'Sí', value: true },
      { text: 'No', value: false },
    ],
    model: {
      id: '',
      name: '',
      last: '',
      email: '',
      phone: '',
      job_position: '',
      brand_ids: [],
      created_between: [],
      updated_between: [],
      has_portal_access: '',
    },
    searchBrands: '',
    isLoadingBrands: false,
    brands: [],
  }),
  computed: {
    brandItems () {
      const list = this.brands || []
      return list.map(function (b) {
        return {
          id: b.id,
          name: b.name,
          agency: b.agency
        }
      })
    },
    createdBetweenLabel () {
      const d = this.model.created_between
      return (Array.isArray(d) && d.length === 2 && d[0] && d[1]) ? (d[0] + ' a ' + d[1]) : ''
    },
    updatedBetweenLabel () {
      const d = this.model.updated_between
      return (Array.isArray(d) && d.length === 2 && d[0] && d[1]) ? (d[0] + ' a ' + d[1]) : ''
    },
    counter () {
      var c = 0
      var m = this.model
      if (m.id) c++
      if (m.name) c++
      if (m.last) c++
      if (m.email) c++
      if (m.phone) c++
      if (m.job_position) c++
      if (Array.isArray(m.brand_ids) && m.brand_ids.length) c++
      if (Array.isArray(m.created_between) && m.created_between.length === 2 && m.created_between[0] && m.created_between[1]) c++
      if (Array.isArray(m.updated_between) && m.updated_between.length === 2 && m.updated_between[0] && m.updated_between[1]) c++
      if (m.has_portal_access !== '') c++
      return c
    },
  },
  watch: {
    searchBrands (val) {
      if (this.isLoadingBrands) return
      this.isLoadingBrands = true
      const base = process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/brands?'
      const url  = base + 'filter[name]=' + encodeURIComponent(val || '')
      axios.get(url)
        .then(res => {
          this.brands = (res && res.data && res.data.data) ? res.data.data : []
        })
        .finally(() => { this.isLoadingBrands = false })
    }
  },
  created () {
    const saved = localStorage.getItem('selectorFiltersContacts')
    if (saved) {
      try { this.model = JSON.parse(saved) } catch (e) {}
    }
  },
  methods: {
    closeDatePicker (dates) {
      return Array.isArray(dates) && dates.length === 2 && dates[0] && dates[1]
    },
    apply () {
      var qs = ''
      var m = this.model

      if (m.id)           qs += '&filter[id]=' + encodeURIComponent(m.id)
      if (m.name)         qs += '&filter[name]=' + encodeURIComponent(m.name)
      if (m.last)         qs += '&filter[last]=' + encodeURIComponent(m.last)
      if (m.email)        qs += '&filter[email]=' + encodeURIComponent(m.email)
      if (m.phone)        qs += '&filter[phone]=' + encodeURIComponent(m.phone)
      if (m.job_position) qs += '&filter[job_position]=' + encodeURIComponent(m.job_position)

      if (Array.isArray(m.brand_ids) && m.brand_ids.length) {
        qs += '&filter[brand_id]=' + m.brand_ids.join(',')
      }
      if (Array.isArray(m.created_between) && m.created_between.length === 2 && m.created_between[0] && m.created_between[1]) {
        qs += '&filter[created_between]=' + m.created_between[0] + ',' + m.created_between[1]
      }
      if (Array.isArray(m.updated_between) && m.updated_between.length === 2 && m.updated_between[0] && m.updated_between[1]) {
        qs += '&filter[updated_between]=' + m.updated_between[0] + ',' + m.updated_between[1]
      }
      if (m.has_portal_access !== '') {
        qs += '&filter[has_portal_access]=' + (m.has_portal_access ? 1 : 0)
      }

      localStorage.setItem('selectorFiltersContacts', JSON.stringify(this.model))
      localStorage.setItem('filtersContacts', JSON.stringify(qs.slice(1)))
      localStorage.setItem('filtersContactsLength', String(this.counter))

      this.$nextTick(() => {
        this.$emit('filtersContacts', false)
      })
    },
    removeFilter () {
      this.model = {
        id: '',
        name: '',
        last: '',
        email: '',
        phone: '',
        job_position: '',
        brand_ids: [],
        created_between: [],
        updated_between: [],
        has_portal_access: '',
      }
      this.brands = []
      localStorage.removeItem('selectorFiltersContacts')
      localStorage.removeItem('filtersContacts')
      localStorage.removeItem('filtersContactsLength')
      this.$nextTick(() => {
        this.$emit('filtersContacts', false)
      })
    },
  }
}
</script>

<style>
.v-text-field { padding-top:10px; margin-top:0px; }
</style>
